import React, { useMemo, useState } from 'react';
import { Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import InstalledBaseTDAForm from '../../../InstalledBaseTDAForm';
import { FormStepProps } from '../../types';
import { decorateSpecificationAttributes, isGasBallastEnabled } from '../../../../utils/serviceDataValidation';

const SpecificationsStep = ({ attributes, initialValues, formikRef }: FormStepProps) => {
    const { t } = useTranslation();
    // Live gate for the gas ballast type field; TDAForm fires onValuesChange on
    // mount and on every change, so this stays in sync with the actual checkbox.
    const [gasBallastOn, setGasBallastOn] = useState(() => isGasBallastEnabled(initialValues));

    const visibleAttributes = useMemo(
        () => decorateSpecificationAttributes(attributes, gasBallastOn, t),
        [attributes, gasBallastOn, t]
    );

    if (attributes.length === 0) {
        return (
            <Typography level="body-md" sx={{ color: 'text.secondary' }}>
                {t('No specification attributes available')}
            </Typography>
        );
    }

    return (
        <InstalledBaseTDAForm
            attributes={visibleAttributes}
            // gasBallastType must stay in the initial values even while its field is
            // filtered out: TDAForm rebuilds initialValues from the attribute list and
            // a changed key set would make Formik reset the whole step on toggle.
            initialFormValues={{ gasBallastType: null, ...initialValues }}
            onValuesChange={(values) => setGasBallastOn(isGasBallastEnabled(values))}
            setFormikHelpersRef={(ref) => { formikRef.current = ref; }}
            enableReinitialize={true}
        />
    );
};

export default SpecificationsStep;
